import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubProject } from '../../model/project/sub-project';
import { Project } from '../../model/project/project';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import { Subject } from 'rxjs';
import Product from 'src/app/model/product/product';
import ProjectContact from 'src/app/model/company/projectContact';
import { BoardPartAddedEvent } from 'src/app/events/board-part-added';
import { StandardStickerPartAddedEvent } from 'src/app/events/standard-sticker-part-added';
import { StandardStickerPartDeletedEvent } from 'src/app/events/standard-sticker-part-deleted';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';

@Component({
  selector: 'edit-view-picker',
  templateUrl: './edit-view-picker.component.html',
  styleUrls: ['./edit-view-picker.component.scss'],
})
export class EditViewPickerComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  subproject: SubProject;

  public gettingNewComponent = true;

  public subProjectChanged: Subject<LoadSubprojectEvent> =
    new Subject<LoadSubprojectEvent>();
  forceRefresh = new EventEmitter();
  @Input()
  project: Project;
  @Input()
  productAdded: Subject<Product>;
  @Input()
  boardPartAdded: Subject<BoardPartAddedEvent>;
  @Input()
  standardStickerPartAdded: Subject<StandardStickerPartAddedEvent>;
  @Input()
  standardStickerPartDeleted: Subject<StandardStickerPartDeletedEvent>;
  @Input()
  projectContactIdAssigned: Subject<ProjectContact[]>;
  @Output()
  save = new EventEmitter();
  @Output()
  deleted = new EventEmitter();

  loadSubProject = true;
  projectHasIPBoards: boolean;

  constructor() {
    super();
  }

  ngOnInit() {
    this.calculateProjectHasIPBoards();
    this.addSubscription(this.subProjectChanged, (loadSubProjectEvent) => {
      this.gettingNewComponent = true;
      setTimeout(() => {
        this.gettingNewComponent = false;
      }, 100);
    });
    this.addSubscription(
      this.forceRefresh,
      () => {
        this.gettingNewComponent = false;
      },
      () => {},
      100
    );
    this.gettingNewComponent = false;
  }

  saveSubproject(value) {
    this.subproject = value;
    this.save.emit(this.subproject);
  }

  setSubToNull() {
    this.subproject = null;
  }

  private calculateProjectHasIPBoards(): void {
    this.projectHasIPBoards =
      CollectionHelper.isPopulated(this.project.products) &&
      this.project.products.some((p) => ProductHelper.isIPBoard(p));
  }
}

export class LoadSubprojectEvent {
  subProject: SubProject;
  doLoadRequest: boolean;
}
